import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Occupation from '@/view/record/occupation/Occupation'

export default {
  path: '/occupation',
  name: 'Occupation',
  components: {
    default: Occupation,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Ocupação' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/OccupationRoute.js